<template>
  <v-card>
    <v-container class="py-0">
      <v-row>
        <v-col cols="auto" class="pr-0">
          <v-avatar size="32" color="performance">
            <v-icon color="white" size="20">$vuetify.icons.core_counts </v-icon>
          </v-avatar>
        </v-col>
        <v-col class="my-auto performance--text">
          Meeting Assistant
        </v-col>
      </v-row>
      <v-row class="subtitle-1 secondarytext--text">
        <v-col cols="12">
          Let's talk about something positive! {{ fullName }} has been
          recognized!
        </v-col>
      </v-row>
    </v-container>
    <template v-for="recognition in recognitions">
      <recognition-line-item
        class="mx-0"
        :key="recognition.id"
        :recognition="recognition"
      ></recognition-line-item>
    </template>
  </v-card>
</template>

<script>
import RecognitionLineItem from "@/components/checkin/RecognitionLineItem";
import { mapGetters } from "vuex";
export default {
  components: { RecognitionLineItem },
  name: "RecognitionTalkingPoint",
  props: {},
  data: () => ({}),
  watch: {},
  computed: {
    fullName() {
      return this.checkin.attendees
        .filter(x => x.id == this.checkin.userIdFor1on1)
        .map(x => x.fullName)[0];
    },
    isCheckinComplete() {
      return this.checkin.completeDate != null;
    },
    recognitions() {
      let recognitions = [];
      if (!this._.isEmpty(this.checkin)) {
        recognitions = this.checkin.recognitions;
      }

      return this._.orderBy(recognitions, ["createdDate"], ["asc"]);
    },
    ...mapGetters({ checkin: "checkin/checkin" })
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.v-card {
  border-top: solid 8px var(--v-performance-base);
}
</style>
